import RestAPI from "../../../util/RestAPI";
import { Lobby } from "../Types/LobbyTypes";

export async function listLobbies() {
  try {
    const resp = await RestAPI.get("/lobbies");
    const lobbies = (await resp.json()) as any as Lobby[];

    return lobbies;
  } catch (err: any) {
    throw new Error(err.message);
  }
}
